export const getFileNameWithoutExtension = (file: File) => {
  // When there is no extension, lastIndexOf will return -1.
  // When passing -1 as indexEnd (2nd argument) to substring it treats it as zero.
  // In this case returning empty string, which then falls back to just file.name.
  return file.name.substring(0, file.name.lastIndexOf('.')) || file.name;
};
